import { template as template_955be08d0e5a4ec78f230c7eb5c121d8 } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import { array } from '@ember/helper';
import { BoxelDropdown, ContextButton, Menu } from '@cardstack/boxel-ui/components';
import { menuDivider, menuItem } from '@cardstack/boxel-ui/helpers';
import { Warning as WarningIcon } from '@cardstack/boxel-ui/icons';
interface Signature {
    Args: {
        toggleSettings: () => void;
        toggleRemoveModal: () => void;
    };
    Yields: {
        default: [];
    };
    Element: HTMLElement;
}
const ContextMenuButton: TemplateOnlyComponent<Signature> = template_955be08d0e5a4ec78f230c7eb5c121d8(`
  <BoxelDropdown @contentClass='context-menu'>
    <:trigger as |bindings|>
      <ContextButton
        class='context-menu-trigger'
        @icon='context-menu-vertical'
        @size='small'
        @label='field options'
        {{bindings}}
        ...attributes
      />
    </:trigger>
    <:content as |dd|>
      <div class='warning-box'>
        <p class='warning'>
          These actions will break compatibility with existing card instances.
        </p>
        <WarningIcon
          class='warning-icon'
          width='20px'
          height='20px'
          role='presentation'
        />
      </div>
      <Menu
        class='context-menu-list'
        @items={{array
          (menuItem 'Edit Field Settings' @toggleSettings)
          (menuDivider)
          (menuItem 'Remove Field' @toggleRemoveModal dangerous=true)
        }}
        @closeMenu={{dd.close}}
      />
    </:content>
  </BoxelDropdown>

  <style scoped>
    :global(.context-menu) {
      width: 13.5rem;
    }

    .context-menu-trigger {
      margin-left: 2px;
    }

    .context-menu-list {
      --boxel-menu-item-content-padding: var(--boxel-sp-xs) var(--boxel-sp-sm);
      border-top-right-radius: 0;
      border-top-left-radius: 0;
    }

    .warning-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: var(--boxel-sp-xxxs);
      padding: var(--boxel-sp-sm);
      background-color: var(--boxel-warning-100);
      border-top-right-radius: inherit;
      border-top-left-radius: inherit;
    }

    .warning {
      margin: 0;
    }

    .warning-icon {
      flex-shrink: 0;
    }
  </style>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default ContextMenuButton;
